<template>
  <select :value="value" @change="e => $emit('input', e.target.value)">
    <option v-for="option in options" :key="option.value" :value="option.value">{{option.label}}</option>
  </select>
</template>

<script>
  export default {
    props: {
      required: Boolean,
      disabled: Boolean,
      options: Array, //{ label: 'Some', value: 1 }
      value: null
    }
  }
</script>

<style scoped lang="scss">
  @import "../../styles/variables";

  select {
    position: relative;
    height: 30px;
    width: calc(100% - 15px);
    padding: 0 25px 0 5px;
    border: none;
    border-left: 2px solid $form-grey;
    border-radius: 0 4px 4px 0;
    background: $form-grey;
    color: $light-text-color;
    font-size: 14px;
    font-weight: 400;
    outline: none;
    transform: scale(1);
    transition: all 200ms;

    &:focus {
      width: 100%;
      border-left: 2px solid $main-blue;
    }

    &:disabled {
      background-color: #eee;
    }

    .dark & {
      background-color: $bg-grey;
      border-color: $bg-grey;
      color: $dark-grey;

      &:focus {
        width: 100%;
        border-left: 2px solid $main-blue;
        color: $dark-grey;
      }

      &::placeholder {
        color: $label-color;
      }
    }
  }
</style>